import comSpSkeleton from "../../../engines/components/comSpSkeleton";
import O1HD from "../../../engines/gameEngine";
import utilsModel from "../../../engines/libs/utilsModel";
import { MessageEventKind } from "../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME } from "../BundleResourceConfig";
import NormalGameManager from "../manager/NormalGameManager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class level66 extends cc.Component {

    private readonly soundTimeMap: { [name: string]: number } = {
        "dudiao": 0,
        "hanbianxue": 0,
        "hanzichui": 0,
        "jing": 0,
        "jinghuawan": 0,
        "jueshaniao": 0,
        "mieren": 0,
        "shan": 0,
        "shanhuadong": 0,
        "wengshangchuanzhihou": 0,
        "wengthree": 0,
        "zhou": 0
    }

    @property({ type: cc.Node, displayName: "需要操作的所有字节点" })
    fonts: cc.Node[] = []

    @property({ type: cc.Node, displayName: "画中的山" })
    painterMountain: cc.Node = null;

    @property({ type: cc.Node, displayName: "画中的鸟" })
    painterBried: cc.Node = null;

    @property({ type: cc.Node, displayName: "画中的人" })
    painterPeople: cc.Node = null;

    @property({ type: cc.Node, displayName: "画中的鸟右边的碰撞" })
    painterBriedTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "山Mask" })
    mountainMask: cc.Node = null;

    @property({ type: cc.Node, displayName: "径的碰撞节点" })
    jingTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "径的mask" })
    jingMask: cc.Node = null;

    @property({ type: cc.Node, displayName: "鸟的mask" })
    briedMask: cc.Node = null;

    @property({ type: cc.Node, displayName: "鸟的mask" })
    renMask: cc.Node = null;

    @property({ type: cc.Node, displayName: "画中的人碰撞节点" })
    peopleTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "画中的江面碰撞节点" })
    sinkTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "江中的船的碰撞节点" })
    sinkShipTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "寒的碰撞" })
    hanTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "天空的碰撞" })
    skyTrigger: cc.Node = null;

    @property({ type: cc.Node, displayName: "雨的碰撞" })
    yuTrigger: cc.Node = null;

    @property({type:cc.Node,tooltip:"遮罩节点"})
    maskNode:cc.Node = null;

    initPos: cc.Vec2[] = [];

    moveSpeed: number = 400;

    audioId: number = null;

    onLoad() {
        this.startAni();
        this.initLevel();
    }

    initLevel() {
        for (let i = 0; i < this.fonts.length; i++) {
            let n = this.fonts[i];
            n.on('touchstart', this.onTouchFontStart, this);
            n.on('touchmove', this.onTouchFontMove, this);
            n.on('touchend', this.onTouchFontEnd, this);
            n.on('touchcancel', this.onTouchFontEnd, this);
            let pos = n.getPosition().clone();
            this.initPos.push(pos);
        }
    }

    miePos: cc.Vec2 = null;
    shanPos: cc.Vec2 = null;
    zhouPos: cc.Vec2 = null;
    wengPos: cc.Vec2 = null;
    jingPos: cc.Vec2 = null;
    hanPos: cc.Vec2 = null;
    juePos: cc.Vec2 = null;
    yuPos: cc.Vec2 = null;

    private fontCanHandler: boolean = true;

    onTouchFontStart(e: cc.Event.EventTouch) {
        if (!this.fontCanHandler) {
            return;
        }
        let n: cc.Node = e.target;
        switch (n.name) {
            case "mie": {
                this.miePos = n.getPosition().clone();
                break;
            }
            case "shan": {
                this.shanPos = n.getPosition().clone();
                break;
            }
            case "zhou": {
                this.zhouPos = n.getPosition().clone();
                break;
            }
            case "weng": {
                this.wengPos = n.getPosition().clone();
                break;
            }
            case "jing": {
                this.jingPos = n.getPosition().clone();
                break;
            }
            case "han": {
                this.hanPos = n.getPosition().clone();
                break;
            }
            case "jue": {
                this.juePos = n.getPosition().clone();
                break;
            }
            case "yu": {
                this.yuPos = n.getPosition().clone();
                break;
            }
        }
    }

    onTouchFontMove(e: cc.Event.EventTouch) {
        if (!this.fontCanHandler) {
            return;
        }
        let n: cc.Node = e.target;
        switch (n.name) {
            case "mie": {
                if (this.miePos) {
                    this.onMieMove(e);
                }
                break;
            }
            case "shan": {
                this.shanPos && this.onShanMove(e);
                break;
            }
            case "zhou": {
                this.zhouPos && this.onZhouMove(e);
                break;
            }
            case "weng": {
                this.wengPos && this.onWengMove(e)
                break;
            }
            case "jing": {
                this.jingPos && this.onJingMove(e);
                break;
            }
            case "han": {
                this.hanPos && this.onHanMove(e);
                break;
            }
            case "jue": {
                this.juePos && this.onJueMove(e);
                break;
            }
            case "yu": {
                this.yuPos && this.onYuMove(e);
                break;
            }
        }
    }

    onTouchFontEnd(e: cc.Event.EventTouch) {
        if (!this.fontCanHandler) {
            return;
        }
        let n: cc.Node = e.target;
        switch (n.name) {
            case "mie": {
                this.miePos && this.onMieEnd(e);
                break;
            }
            case "shan": {
                this.shanPos && this.onShanEnd(e);
                break;
            }
            case "zhou": {
                this.zhouPos && this.onZhouEnd(e);
                break;
            }
            case "weng": {
                this.wengPos && this.onWengEnd(e);
                break;
            }
            case "jing": {
                this.jingPos && this.onJingEnd(e);
                break;
            }
            case "han": {
                this.hanPos && this.onHanEnd(e);
                break;
            }
            case "jue": {
                this.juePos && this.onJueEnd(e);
                break;
            }
            case "yu": {
                this.yuPos && this.onYuEnd(e);
                break;
            }
        }
    }
    //山字的状态 0是普通状态 1是已经拖到了画中的山上 2是山字已经消失 （即画上的山已经全部展现）
    shanState: number = 0;
    //是否可以移动山
    canMoveShan: boolean = true;
    // firstShan:boolean = true;
    onShanMove(e: cc.Event.EventTouch) {
        if (!this.canMoveShan) return;
        let shan: cc.Node = e.target;
        let delta = e.getDelta();
        if (this.shanState == 0) {
            shan.x += delta.x;
            shan.y += delta.y;
        } else if (this.shanState == 1) {
            if (delta.x > 0) {
                shan.x += delta.x;
                let width = shan.x + O1HD.Canvas().width / 2;
                if (this.mountainMask.width < width) {
                    this.mountainMask.width = width;
                }
                if (shan.x >= -30) {
                    // 山全部显示出来 并且字消失
                    O1HD.getManagers().soundMgr.playSound("shanchuxian",null,BUNDLE_SMALL_NAME.antiphonalVerse);
                    this.scheduleOnce(() => {
                        O1HD.getManagers().soundMgr.playSound("niaojiao",null,BUNDLE_SMALL_NAME.antiphonalVerse);
                        this.schedule(this.niaojiao, 4.5);
                    }, 0.3);
                    cc.tween(this.mountainMask).to(1, { width: 750 }).call(() => {
                        this.playSound("shanhuadong");
                    }).start();
                    // this.mountainMask.width = 750;
                    shan.targetOff(this);
                    this.shanState = 2;
                    cc.tween(shan).to(0.3, { opacity: 0 }).start();
                }
            }
        }
    }

    onShanEnd(e: cc.Event.EventTouch) {
        let shan: cc.Node = e.target;
        if (this.shanState == 0 && shan.getBoundingBoxToWorld().intersects(this.painterMountain.getBoundingBoxToWorld())) {
            this.playSound("shan");
            this.shanState = 1;
            this.canMoveShan = false;
            // 校正山的位置 校正完成之后将锁放开
            let p = this.painterMountain.convertToWorldSpaceAR(cc.v2());
            let pos = shan.parent.convertToNodeSpaceAR(p);
            let time = pos.sub(shan.getPosition()).mag() / this.moveSpeed;
            //@ts-ignore
            cc.tween(shan).to(time, { position: pos }).call(() => {
                this.canMoveShan = true;
            }).start();
        } else {
            shan.setPosition(this.shanPos);
        }
    }

    //绝字的状态  0 是普通状态  1是已经放到了鸟的右边 2是已经消失（即鸟已经飞绝）
    jueState: number = 0;
    //是否可以移动绝
    canMoveJue: boolean = true;

    onJueMove(e: cc.Event.EventTouch) {
        let jue: cc.Node = e.target;
        let delta = e.getDelta();
        if (!this.canMoveJue) return;
        if (this.shanState != 2) {
            jue.x += delta.x;
            jue.y += delta.y;
        } else {
            if (this.jueState == 0) {
                //随意移动
                jue.x += delta.x;
                jue.y += delta.y;
            } else if (this.jueState == 1) {
                //只能移动x轴  并且只能往右移动
                let deltaX = delta.x;
                if (deltaX < 0) {
                    jue.x += deltaX;
                    if (this.painterBried.getBoundingBoxToWorld().contains(jue.convertToWorldSpaceAR(cc.v2()))) {
                        jue.targetOff(this);
                        this.jueState = 2;
                        this.unschedule(this.niaojiao);
                        let jx = jue.x;
                        cc.tween(jue).to(1, { x: jx - 243, opacity: 0 }).start();
                        cc.tween(this.briedMask).to(1, { width: 0 }).call(() => {
                            this.playSound("jueshaniao");
                        }).start();
                        // cc.tween(this.painterBried).to(0.3,{opacity:0}).start();
                    }
                }
            }

        }
    }

    onJueEnd(e: cc.Event.EventTouch) {
        let jue: cc.Node = e.target;
        if (this.shanState != 2) {
            jue.setPosition(this.juePos);
            return;
        }
        if (this.jueState == 0) {
            if (jue.getBoundingBoxToWorld().intersects(this.painterBriedTrigger.getBoundingBoxToWorld())) {
                // this.playSound("jing");
                this.jueState = 1;
                let pos = this.painterBriedTrigger.convertToWorldSpaceAR(cc.v2());
                let targetPos = jue.parent.convertToNodeSpaceAR(pos);
                let time = jue.getPosition().sub(targetPos).mag() / this.moveSpeed;
                this.canMoveJue = false;
                //@ts-ignore
                cc.tween(jue).to(time, { position: targetPos }).call(() => {
                    this.canMoveJue = true;
                }).start();
            } else {
                jue.setPosition(this.juePos);
            }
        } else {
            jue.setPosition(this.juePos);
        }
    }

    //径的状态 0 是普通状态 1是已经拖到路上了 2 是已经消失了（即径）
    jingState: number = 0;
    canMoveJing: boolean = true;

    onJingMove(e: cc.Event.EventTouch) {
        if (!this.canMoveJing) return;
        let jing: cc.Node = e.target;
        let detal = e.getDelta();
        if (this.jueState != 2) {
            jing.x += detal.x;
            jing.y += detal.y;
        } else {
            if (this.jingState == 0) {
                jing.x += detal.x;
                jing.y += detal.y;
            } else if (this.jingState == 1) {
                let detalY: number = detal.y;
                if (detalY < 0) {
                    jing.y += detalY;
                    let jy = jing.y;
                    // let jingHeight:number = Math.abs(jy);
                    // if(this.jingMask.height<jingHeight){
                    //     this.jingMask.height = jingHeight;
                    // }
                    O1HD.getManagers().soundMgr.playSound("jingchuxian",null,BUNDLE_SMALL_NAME.antiphonalVerse);
                    O1HD.getManagers().soundMgr.playSound("renshuohua",null,BUNDLE_SMALL_NAME.antiphonalVerse);
                    this.schedule(this.renshuohua, 6);
                    cc.tween(this.jingMask).to(0.3, { height: 300 }).call(() => {
                        this.playSound("jinghuawan");
                    }).start();
                    // if(jing.y<-280){
                    // this.jingMask.height = 300;
                    jing.targetOff(this);
                    cc.tween(jing).to(0.3, { opacity: 0 }).start();
                    this.jingState = 2;
                    // }
                }
            } else {

            }
        }
    }

    onJingEnd(e: cc.Event.EventTouch) {
        let jing: cc.Node = e.target;
        if (this.jueState != 2) {
            jing.setPosition(this.jingPos);
            return;
        }
        if (this.jingState == 0) {
            if (this.jingTrigger.getBoundingBoxToWorld().intersects(jing.getBoundingBoxToWorld())) {
                this.playSound("jing");
                this.jingState = 1;
                let p = this.jingTrigger.convertToWorldSpaceAR(cc.v2());
                let pos = jing.parent.convertToNodeSpaceAR(p);
                let distance = jing.getPosition().sub(pos).mag();
                let time = distance / this.moveSpeed;
                this.canMoveJing = false;
                //@ts-ignore
                cc.tween(jing).to(time, { position: pos }).call(() => {
                    this.canMoveJing = true;
                }).start();
            } else {
                jing.setPosition(this.jingPos);
            }
        } else {
            jing.setPosition(this.jingPos);
        }
    }

    //灭的状态 0表示普通状态 1表示已经放在了人的下面 2表示已经把人都给消掉了
    mieState: number = 0;
    canMoveMie: boolean = true;
    onMieMove(e: cc.Event.EventTouch) {
        if (!this.canMoveMie) return;
        let mie: cc.Node = e.target;
        let detal = e.getDelta();
        if (this.jingState != 2) {
            mie.x += detal.x;
            mie.y += detal.y;
        } else {
            if (this.mieState == 0) {
                mie.x += detal.x;
                mie.y += detal.y;
            } else if (this.mieState == 1) {
                let dy = detal.y;
                if (dy > 0) {
                    mie.y += dy;
                    if (this.painterPeople.getBoundingBoxToWorld().contains(mie.convertToWorldSpaceAR(cc.v2()))) {
                        this.mieState = 2;
                        mie.targetOff(this);
                        this.unschedule(this.renshuohua);
                        let my = mie.y;
                        cc.tween(mie).to(0.3, { y: my + 30, opacity: 0 }).start();
                        cc.tween(this.renMask).to(0.3, { height: 0 }).call(() => {
                            this.playSound("mieren");
                        }).start();
                    }
                }
            }
        }
    }

    onMieEnd(e: cc.Event.EventTouch) {
        let mie: cc.Node = e.target;
        if (this.jingState != 2) {
            mie.setPosition(this.miePos);
            return;
        }
        if (this.mieState == 0) {
            if (mie.getBoundingBoxToWorld().intersects(this.peopleTrigger.getBoundingBoxToWorld())) {
                this.mieState = 1;
                let p = this.peopleTrigger.convertToWorldSpaceAR(cc.v2());
                let targetP = mie.parent.convertToNodeSpaceAR(p);
                let time = mie.getPosition().sub(targetP).mag() / this.moveSpeed;
                this.canMoveMie = false;
                //@ts-ignore
                cc.tween(mie).to(time, { position: targetP }).call(() => {
                    this.canMoveMie = true;
                }).start();
            } else {
                mie.setPosition(this.miePos);
            }

        } else {
            mie.setPosition(this.miePos);
        }
    }

    //舟的状态 0表示普通状态 1表示放在了江上
    zhouState: number = 0;
    onZhouMove(e: cc.Event.EventTouch) {
        let zhou: cc.Node = e.target;
        let detal = e.getDelta();
        zhou.x += detal.x;
        zhou.y += detal.y;
        // if(this.mieState ==2){
        //     if(this.sinkTrigger.getBoundingBoxToWorld().intersects(zhou.getBoundingBoxToWorld())){

        //     }
        // }
    }

    onZhouEnd(e: cc.Event.EventTouch) {
        let zhou: cc.Node = e.target;
        if (this.mieState == 2) {
            if (this.sinkTrigger.getBoundingBoxToWorld().intersects(zhou.getBoundingBoxToWorld())) {
                this.zhouState = 1;
                zhou.targetOff(this);
                let zNode = zhou.getChildByName("label");
                let zAni = zhou.getChildByName("GuZhou");
                let p = this.sinkTrigger.convertToWorldSpaceAR(cc.v2());
                let pos = zhou.parent.convertToNodeSpaceAR(p);
                let time = zhou.getPosition().sub(pos).mag() / this.moveSpeed;
                //@ts-ignore
                cc.tween(zhou).to(time, { position: pos }).call(() => {
                    cc.tween(zNode).to(0.3, { angle: -90 }).call(() => {
                        cc.tween(zNode).to(0.3, { opacity: 0 }).start();
                        cc.tween(zAni).to(0.3, { opacity: 255 }).call(() => {
                            O1HD.getManagers().soundMgr.playSound("zhoubianchuan",null,BUNDLE_SMALL_NAME.antiphonalVerse)
                            cc.tween(zhou).by(0.3, { y: -20 }, { easing: cc.easing.circInOut }).call(() => {
                                zAni.getComponent(sp.Skeleton).setAnimation(0, "Zhou_Piao", true);
                                this.playSound("zhou")
                            }).start();
                        }).start();
                    }).start();
                }).start();

            } else {
                zhou.setPosition(this.zhouPos);
            }
        } else {
            zhou.setPosition(this.zhouPos);
        }
    }

    //翁的状态 0表示普通状态 1表示已经坐在了船上 2表示已经把钓竿拿出来了
    wengState: number = 0;

    canTouchweng: boolean = true;

    onWengMove(e: cc.Event.EventTouch) {
        let weng: cc.Node = e.target;
        let detal = e.getDelta();
        if (!this.canTouchweng) {
            return;
        }
        if (this.zhouState != 1) {
            weng.x += detal.x;
            weng.y += detal.y;
        } else {
            if (this.wengState == 0) {
                weng.x += detal.x;
                weng.y += detal.y;
            } else if (this.wengState == 1) {
                let sx = e.getStartLocation().x;
                let ex = e.getLocationX();
                if (sx - ex > 30) {
                    this.unschedule(this.onWengThree);
                    this.wengState = 2;
                    weng.targetOff(this);
                    let wengAni = weng.getChildByName("GuZhou").getComponent(sp.Skeleton);
                    wengAni.node.active = true;
                    weng.getChildByName("label").active = false;
                    wengAni.setAnimation(0, "Weng_DiaoYu", false);
                    O1HD.getManagers().soundMgr.playSound("yugangchuxian",null,BUNDLE_SMALL_NAME.antiphonalVerse);
                    wengAni.setEndListener(() => {
                        this.playSound("dudiao");
                        wengAni.setCompleteListener(null);
                    })
                    //  翁字的下半部分伸出一根钓竿开始钓鱼
                }
            }
        }
    }

    onWengEnd(e: cc.Event.EventTouch) {
        let weng: cc.Node = e.target;
        if (this.zhouState == 1 && this.wengState == 0) {
            if (this.sinkShipTrigger.getBoundingBoxToWorld().intersects(weng.getBoundingBoxToWorld())) {
                this.wengState = 1;
                this.canTouchweng = false;
                let p = this.sinkShipTrigger.convertToWorldSpaceAR(cc.v2(-50, 50));
                let pp = weng.parent.convertToNodeSpaceAR(p);
                let time = pp.sub(weng.getPosition()).mag() / this.moveSpeed;
                O1HD.getManagers().soundMgr.playSound("wengshangchuan",null,BUNDLE_SMALL_NAME.antiphonalVerse)
                //@ts-ignore
                cc.tween(weng).to(time, { position: pp }).call(() => {
                    this.canTouchweng = true;
                    this.playSound("wengshangchuanzhihou")
                    this.scheduleOnce(this.onWengThree, 3);
                }).start();
                // 移动到船的上面位置
            } else {
                weng.setPosition(this.wengPos);
            }
        } else {
            weng.setPosition(this.wengPos);
        }
    }

    onWengThree() {
        this.playSound('level66/wengthree')
    }

    //寒的状态 0是普通形态 1是已经固定在天空上
    hanState: number = 0;
    onHanMove(e: cc.Event.EventTouch) {
        let han: cc.Node = e.target;
        let detal = e.getDelta();
        han.x += detal.x;
        han.y += detal.y;
    }

    onHanEnd(e: cc.Event.EventTouch) {
        let han: cc.Node = e.target;
        if (this.wengState == 2) {
            if (this.hanTrigger.getBoundingBoxToWorld().intersects(this.skyTrigger.getBoundingBoxToWorld())) {
                han.targetOff(this);
                this.hanState = 1;
                let p = this.skyTrigger.convertToWorldSpaceAR(cc.v2());
                let pos = han.parent.convertToNodeSpaceAR(p);
                let time = pos.sub(han.getPosition()).mag() / this.moveSpeed;
                //@ts-ignore
                cc.tween(han).to(time, { position: pos }).call(() => {
                    if (this.hanTrigger.getBoundingBoxToWorld().intersects(this.yuTrigger.getBoundingBoxToWorld())) {
                        let pp = this.hanTrigger.convertToWorldSpaceAR(cc.v2());
                        let yu = this.yuTrigger.parent
                        let ppos = yu.parent.convertToNodeSpaceAR(pp);
                        let time = ppos.sub(yu.getPosition()).mag() / this.moveSpeed;
                        //@ts-ignore
                        cc.tween(yu).to(time, { position: ppos }).start();
                        this.winAni(han, yu);
                    }
                }).start();
            } else {
                han.setPosition(this.hanPos);
            }
        } else {
            han.setPosition(this.hanPos);
        }
    }

    onYuMove(e: cc.Event.EventTouch) {
        let yu: cc.Node = e.target;
        let detal = e.getDelta();
        yu.x += detal.x;
        yu.y += detal.y;
    }

    onYuEnd(e: cc.Event.EventTouch) {
        let n = e.target;
        if (this.hanState == 1) {
            if (this.hanTrigger.getBoundingBoxToWorld().intersects(this.yuTrigger.getBoundingBoxToWorld())) {
                let han = this.hanTrigger.parent;
                let pp = this.hanTrigger.convertToWorldSpaceAR(cc.v2());
                let yu = this.yuTrigger.parent;
                yu.targetOff(this);
                let ppos = yu.parent.convertToNodeSpaceAR(pp);
                let time = ppos.sub(yu.getPosition()).mag() / this.moveSpeed;
                //@ts-ignore
                cc.tween(yu).to(time, { position: ppos }).call(() => {
                    this.winAni(han, yu);
                }).start();
            } else {
                n.setPosition(this.yuPos);
            }
        } else {
            n.setPosition(this.yuPos);
        }
    }

    //胜利动画
    winAni(hanNode: cc.Node, yuNode: cc.Node) {
        // 胜利??????

        let xue: cc.Node = yuNode.getChildByName("label");
        let xueAni: cc.Node = yuNode.getChildByName("Xue");
        let hanEf: cc.Node = hanNode.getChildByName("ef_Qi");
        hanEf.active = true;
        // console.log(hanEf,"??????????")
        let hanEfAni = hanEf.getComponent(comSpSkeleton);
        O1HD.getManagers().soundMgr.playSound("hanzichui",null,BUNDLE_SMALL_NAME.antiphonalVerse)
        hanEfAni.playAnimation("animation").onComplete(1, () => {
            const width = 2;
            let once = cc.tween(xue)
                .by(0.02, { x: width, y: width })
                .by(0.02, { x: 0, y: -width })
                .by(0.02, { x: -width, y: -width })
                .by(0.02, { x: -width, y: 0 })
                .by(0.02, { x: 0, y: width })
                .by(0.02, { x: width, y: 0 });
            hanEf.active = false;
            O1HD.getManagers().soundMgr.playSound("yubianbing",null,BUNDLE_SMALL_NAME.antiphonalVerse)
            cc.tween(xue).then(once)
                .repeat(3)
                .call(() => {
                    cc.tween(xue).to(0.3, { opacity: 0 }).start();
                    cc.tween(xueAni).to(0.3, { opacity: 255 }).delay(1).call(() => {
                        this.iceAni();
                        this.playSound("hanbianxue");
                        this.Win(5);
                    }).start();
                }).start();
        }).start(false);

        // console.log("胜利!!!!!!!!!!!!!!!!!");
    }

    @property({ type: cc.Node, displayName: "下雪的粒子" })
    ice: cc.Node = null;

    //下雪动画
    iceAni() {
        this.ice.active = true;
        this.ice.getComponent(cc.ParticleSystem).resetSystem();
        this.ice.children[0].getComponent(cc.ParticleSystem).resetSystem();
    }

    async playSound(name) {
        if (this.audioId != null) {
            O1HD.getManagers().soundMgr.stopSound(this.audioId);
        }
        this.audioId = await O1HD.getManagers().soundMgr.playSound(name,null,BUNDLE_SMALL_NAME.antiphonalVerse);
        const delay: number = this.soundTimeMap[name];
        if (delay) {
            this.fontCanHandler = false;
            this.scheduleOnce(() => {
                this.fontCanHandler = true;
            }, delay);
        }
    }

    niaojiao() {
        O1HD.getManagers().soundMgr.playSound("niaojiao",null,BUNDLE_SMALL_NAME.antiphonalVerse);
    }

    renshuohua() {
        O1HD.getManagers().soundMgr.playSound("renshuohua",null,BUNDLE_SMALL_NAME.antiphonalVerse);
    }

    startAni(){
        this.uiNode.active = false;
        return new Promise<void>(resolve=>{
            cc.tween(this.maskNode).to(0.5,{width:2000,height:2000}).call(()=>{
                this.uiNode.active = true;
                resolve();
            }).start();
        });
    }

    endAni(){
        this.uiNode.active = false;
        return new Promise<void>(resolve=>{
            cc.tween(this.maskNode).to(0.5,{width:0,height:0}).call(resolve).start();
        });
    }

    async Win(delayTime:number){
        //  需完善
        this.scheduleOnce(async ()=>{
            await this.endAni();
            NormalGameManager._instance.setGameData({liBaiGoodValue:50});
            O1HD.emit(MessageEventKind.EventName.UPDATE_CUPID_HOUSE_STATE);
            this.node.destroy();
        },delayTime);
    }

    goTips:boolean = false;

    @property({type:cc.Node,tooltip:"提示节点"})
    hintNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"ui节点"})
    uiNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"提示视频图标"})
    video:cc.Node = null;

    onBtnHint(){
        if(this.goTips){
            this.hintNode.active = true;
        }else{
            utilsModel.loadAndShowVideoAdTrans(()=>{
                this.goTips = true;
                this.hintNode.active = true;
                this.video.active = false;
            },()=>{

            },null,"对诗看广告获得提示");
        }
    }

    onBtnHintComit(){
        this.hintNode.active = false;
    }

    onBtnClose(){
        this.endAni().then(()=>{
            this.node.destroy();
        });
    }

}
